import PaymentMethods from './PaymentMethods';

export default PaymentMethods;


// WEBPACK FOOTER //
// ./src/components/PaymentMethods/index.tsx